<template>
  <div class='content-wrapper'>
    <Breadcrumb :title="$t('accountSettings-limit-title')" />
    <div class='content-body'>
      <div class='row'>
        <div class='col-xl-8 col-lg-8 col-md-12'>
          <section class='card'>
            <div class='card-content'>
              <div class='card-body'>
                <Limits />
              </div>
            </div>
          </section>
        </div>
        <Sidebar />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/personal/Sidebar.vue';
import Limits from '@/components/personal/Limit.vue';
import Breadcrumb from '@/components/layout/Breadcrumb';

export default {
  name: 'Limit',
  components: {
    Sidebar,
    Limits,
    Breadcrumb
  }
};
</script>

<style scoped></style>
